import { axiosNTL, axiosNT } from '../../../services/axios';

interface reqParamsBody{
	count: number,
	questionCode: number,
	courseSyllabusIds:any[],
	groupId: string,
	difficultyLevels: any[],
	difficultyTypes: any[],
	goalLevelId?: string,
	contentTags?:any []
}
const listByGrade = (classId = "") => axiosNT
	.get('/subject?classId=' + classId)
	.then((res: any) => Promise.resolve(res.responseObject));

const listByGradeByGoal = (classIds: any[], courseTypeIds: any[]) => axiosNT
	.post('/courseSyllabus/v4/subject', { classIds, courseTypeIds })
	.then((res: any) => Promise.resolve(res.responseObject.subjects));

const fetchSubjects = (payload: any = {}) => axiosNTL
	.get(`/test/subjects/${payload.testId}`)
	.then((res: any) => Promise.resolve(res.responseObject));

const updateSubject = (payload: any = {}) => axiosNT
	.put(`/test/subjects/${payload.testId}`, payload)
	.then((res: any) => Promise.resolve(res.responseObject));


const getRandomQuestions= (reqBody:reqParamsBody)=>{
		return axiosNT.post('question/auto-generate/list',reqBody)
				   .then((res:any)=>{
					let syllabusList: any = res.responseObject;
					return Promise.resolve(syllabusList);
				   })
}
const getRandomQuestionsCount= (reqBody:reqParamsBody)=>{
	return axiosNTL.post('question/auto-generate/count',reqBody)
			   .then((res:any)=>{
				let syllabusList: any = res.responseObject;
				return Promise.resolve(syllabusList);
			   })
}

const subjectsServices = {
	listByGrade,
	listByGradeByGoal,
	fetchSubjects,
	updateSubject,
	getRandomQuestions,
	getRandomQuestionsCount
};

export default subjectsServices;